import React from "react";
import { AquasaveLogo } from "@/components/AquasaveLogo";

export default function ArereReport({ metrics }) {
  if (!metrics) return null;
  const { arera, distretto, utenze, tratti, alerts, timestamp } = metrics;

  return (
    <div className="print-area p-8 bg-white text-black print:p-0" data-testid="print-area">
      <div className="flex items-center justify-between border-b-2 border-[#0F2E5C] pb-4 mb-6">
        <AquasaveLogo size={44} />
        <div className="text-right text-sm">
          <div className="font-heading font-bold text-[#0F2E5C] text-lg">REPORT UFFICIALE BILANCIO IDRICO</div>
          <div className="text-xs text-slate-600">Conforme Delibera ARERA 917/2017/R/idr</div>
          <div className="text-xs font-mono">Emesso: {timestamp}</div>
        </div>
      </div>

      <section className="mb-6">
        <h2 className="font-heading font-bold text-[#0F2E5C] text-xl mb-3">1. Dati Distretto</h2>
        <table className="w-full text-sm">
          <tbody>
            <tr><td className="font-semibold w-1/3">Distretto Idrico</td><td>{distretto.nome}</td></tr>
            <tr><td className="font-semibold">Gestore</td><td>{distretto.gestore}</td></tr>
            <tr><td className="font-semibold">Sviluppo Rete</td><td className="font-mono">{distretto.lunghezza_rete_km} km</td></tr>
            <tr><td className="font-semibold">Data misurazione</td><td className="font-mono">{timestamp}</td></tr>
          </tbody>
        </table>
      </section>

      <section className="mb-6 print-break-inside-avoid">
        <h2 className="font-heading font-bold text-[#0F2E5C] text-xl mb-3">2. Indicatori Macro-Qualità ARERA</h2>
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-100"><th>Codice</th><th>Descrizione</th><th className="text-right">Valore</th></tr></thead>
          <tbody>
            <tr><td className="font-mono font-bold">M1a</td><td>Perdita Percentuale</td><td className="text-right font-mono font-bold kpi-value">{arera.m1a_pct} %</td></tr>
            <tr><td className="font-mono font-bold">M1b</td><td>Perdita Lineare Distrettuale</td><td className="text-right font-mono font-bold kpi-value">{arera.m1b_m3_km_gg} m³/km/giorno</td></tr>
          </tbody>
        </table>
      </section>

      <section className="mb-6 print-break-inside-avoid">
        <h2 className="font-heading font-bold text-[#0F2E5C] text-xl mb-3">3. Bilancio Volumetrico Giornaliero</h2>
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-100"><th>Voce</th><th className="text-right">m³/giorno</th></tr></thead>
          <tbody>
            <tr><td>Volume Immesso in Rete</td><td className="text-right font-mono">{arera.immesso_m3_gg}</td></tr>
            <tr><td>Volume Fatturato Utenze</td><td className="text-right font-mono">{arera.fatturato_m3_gg}</td></tr>
            <tr><td className="font-semibold">Volume Perdite Totali</td><td className="text-right font-mono font-bold kpi-value">{arera.perdite_m3_gg}</td></tr>
          </tbody>
        </table>
      </section>

      <section className="mb-6">
        <h2 className="font-heading font-bold text-[#0F2E5C] text-xl mb-3">4. Analisi Utenze ({utenze.length})</h2>
        <table className="w-full text-xs">
          <thead><tr className="bg-slate-100"><th>ID</th><th>Indirizzo</th><th>Meter</th><th className="text-right">Flusso L/h</th><th className="text-right">Fatt. L/h</th><th className="text-right">Z-Score</th><th>Stato AI</th></tr></thead>
          <tbody>
            {utenze.map((u) => (
              <tr key={u.id}>
                <td className="font-mono">{u.id}</td>
                <td>{u.indirizzo}</td>
                <td className="font-mono">{u.meter_type}</td>
                <td className="text-right font-mono">{u.flusso_istantaneo_lh}</td>
                <td className="text-right font-mono">{u.media_fatturata_lh}</td>
                <td className="text-right font-mono">{u.z_score}</td>
                <td className="font-mono" style={{color: u.allarme==="HIGH"?"#EF4444":"#059669"}}>{u.stato_ai}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="mb-6 print-break-inside-avoid">
        <h2 className="font-heading font-bold text-[#0F2E5C] text-xl mb-3">5. Tratti Condotta</h2>
        <table className="w-full text-xs">
          <thead><tr className="bg-slate-100"><th>ID</th><th>Nome</th><th className="text-right">Ingresso L/h</th><th className="text-right">Uscita L/h</th><th className="text-right">Perdita L/h</th></tr></thead>
          <tbody>
            {tratti.map((t) => (
              <tr key={t.id}>
                <td className="font-mono">{t.id}</td>
                <td>{t.nome}</td>
                <td className="text-right font-mono">{t.ingresso_lh}</td>
                <td className="text-right font-mono">{t.uscita_lh}</td>
                <td className="text-right font-mono" style={{color: t.perdita_lh>1000?"#EF4444":"#059669"}}>{t.perdita_lh}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {alerts.length > 0 && (
        <section className="mb-6">
          <h2 className="font-heading font-bold text-[#EF4444] text-xl mb-3">6. Allarmi Rilevati ({alerts.length})</h2>
          <table className="w-full text-xs">
            <thead><tr className="bg-slate-100"><th>Livello</th><th>Tipo</th><th>Messaggio</th></tr></thead>
            <tbody>
              {alerts.map((a, i) => (
                <tr key={i}>
                  <td className="font-mono font-bold" style={{color:"#EF4444"}}>{a.livello}</td>
                  <td className="font-mono">{a.tipo}</td>
                  <td>{a.messaggio}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      <div className="mt-10 pt-4 border-t border-slate-300 text-xs text-slate-600 font-mono">
        AQUAsave Enterprise Platform · Report generato automaticamente · ML Engine: Claude Sonnet 5 + Z-Score statistico
      </div>
    </div>
  );
}
